<template>
  <el-card
    v-loading="loadingPage"
    class="ProgressaoTPV"
    :body-style="{ padding: '10px' }"
    style="height: 440px"
  >
    <div class="space-between">
      <h3>Progressão de TPV</h3>
      <div :class="{ red: list.percent < 0 }">
        <i v-if="list.percent >= 0" class="el-icon-top-right"></i>
        <i v-else class="el-icon-bottom-right"></i>
        <strong> {{ list.percent }}% </strong>
      </div>
    </div>
    <div class="boxDetalhes">
      <div class="box atual" :style="boxAtualStyle">
        <div class="cont">
          <span>Mês atual</span>
          <strong>R$ {{ list.amountCurrentMonthly.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</strong>
        </div>
      </div>
      <div
        class="box"
        style="border: 1px solid #ececf5; border-radius: 8px; margin-left: 10px"
      >
        <div class="cont">
          <span>Mês anterior</span>
          <strong> R$ {{ list.amountBeforeMonthly.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} </strong>
        </div>
      </div>
    </div>
    <apexchart
      type="line"
      height="265"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import { makeErrorFilds } from "@/app/plugins/utils";
import { getProgressionTPV } from "@/app/domains/Core/services";
export default {
  name: "ProgressaoTPV",
  data() {
    return {
      boxAtualStyle: {
        background: "#003366",
        color: "#fff",
      },
      series: [],
      chartOptions: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        markers: {
          size: 4,
        },
        colors: ["#0277f5"],
        plotOptions: {
          toolbar: {
            show: false,
          },
          line: {
            borderRadius: 10,
            dataLabels: {
              position: "top", // top, center, bottom
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return (
              "" +
              Intl.NumberFormat("pt-BR", {
                style: "decimal",
                currency: "BRL",
                minimumFractionDigits: 2,
              }).format(val)
            );
          },
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#304758"],
          },
        },
        xaxis: {
          tickPlacement: "between",
          labels: {
            formatter: (val) => this.$moment.utc(val).format("MMMM").toUpperCase(),
          },
        },
        yaxis: {
          labels: {
            show: true,
            formatter: function (val) {
              if (Math.abs(val) > 1000000) {
                val = Math.sign(val) * (Math.abs(val) / 1000000).toFixed(1) + "M";
              } else if (Math.abs(val) > 1000) {
                val = Math.sign(val) * (Math.abs(val) / 1000).toFixed(1) + "k";
              }

              return val;
            },
          },
        },
      },
      loadingPage: false,
      list: {
        amountBeforeMonthly: "",
        amountCurrentMonthly: "",
        percent: "",
      },
    };
  },
  computed: {
    ...mapGetters("Auth", ["getColorTheme"]),
  },
  methods: {
    formatReal(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "decimal",
        currency: "BRL",
        minimumFractionDigits: 2,
      }).format(value);
    },
    stringToFloat(number) {
      let res = parseFloat(number.replace(",", ""));
      return res;
    },
  },
  async beforeMount() {
    // Request

    if (this.getColorTheme.colorPrimary != null) {
      this.boxAtualStyle.background = this.getColorTheme.colorPrimary;
    }
    this.$set(this.chartOptions, "colors", [this.getColorTheme.colorPrimary]);
    this.loadingPage = true;
    try {
      let response = await getProgressionTPV();

      const chartArray = Object.values(response.data.chart);

      const transformedArray = chartArray.map((x) => {
        return {
          x: x.month.split("/")[0] + "/01/" + x.month.split("/")[1],
          y: parseFloat(x.value),
        };
      });
      // response.data.chart.map((x) => {
      //   x.x = x.month.split("/")[0] + "/01/" + x.month.split("/")[1];
      //   x.y = this.stringToFloat(x.value);
      // });

      this.series.push({
        name: "Progressão de TPV",
        data: transformedArray,
      });
      this.list = response.data.list;
    } catch (e) {

      this.$message({
        showClose: true,
        message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
        type: "error",
      });
    } finally {
      this.loadingPage = false;
    }
  },
};
</script>
